import { Layouts } from "react-grid-layout";

interface OverviewConfigure {
  layouts: Layouts;
  layoutsDisabled: Layouts;
}

export interface ContainersConfigure extends OverviewConfigure {
  atDC: boolean | 1 | 0;
  atPort: boolean | 1 | 0;
  containerDistributionByDestination: boolean | 1 | 0;
  containersByArrivalDate: boolean | 1 | 0;
  containersStatuses: boolean | 1 | 0;
  inbound: boolean | 1 | 0;
}

export interface ProductsConfigure extends OverviewConfigure {
  mostRequestedProducts: boolean | 1 | 0;
  productsOrigin: boolean | 1 | 0;
  productsRunningOutOfStock: boolean | 1 | 0;
}

export interface OrdersConfigure extends OverviewConfigure {
  lastReceivedOrders: boolean | 1 | 0;
  pendingPurchaseOrders: boolean | 1 | 0;
  poConfirmedVSPoReceived: boolean | 1 | 0;
  poStatuses: boolean | 1 | 0;
  shipByDate: boolean | 1 | 0;
}

export interface ShipmentsConfigure extends OverviewConfigure {
  shipmentsPerDate: boolean | 1 | 0;
  shipmentStatuses: boolean | 1 | 0;
  shipmentsTracked: boolean | 1 | 0;
}

export enum ESupplyChainOverviewTabs {
  CONTAINERS = "containers",
  ORDERS = "orders",
  PRODUCTS = "products",
  SHIPMENTS = "shipments",
}

export interface SupplyChainOverviewConfigure {
  [ESupplyChainOverviewTabs.CONTAINERS]: ContainersConfigure;
  [ESupplyChainOverviewTabs.ORDERS]: OrdersConfigure;
  [ESupplyChainOverviewTabs.PRODUCTS]: ProductsConfigure;
  [ESupplyChainOverviewTabs.SHIPMENTS]: ShipmentsConfigure;
}
